// Направление сортировки
export type SortDirection = 'asc' | 'desc';

// Поле и направление либо оба заданы, либо обоих нет (отсутствие сортировки —
// просто отсутствие SortSpec в массиве). Раньше были independent-nullable,
// и весь код проверял `if (s.field && s.direction)`.
export interface SortSpec {
  field: string;
  direction: SortDirection;
}

// FilterSpec — единый фильтр (как на бэкенде)
export interface FilterSpec {
  field: string | null;
  type: string | null;
  operator: string | null;
  value?: unknown;
  value2?: unknown;
}

// UI-форма запроса поиска. `EquipmentService.search` маршрутизирует:
//   - snapshotDate ≠ today → GET /inventory?asOfDate=… (без filters/sort)
//   - иначе → POST /inventory/search (с filters/sort через адаптер toBackendSearchRequest)
// snapshotDate в ТЗ-форме здесь, в backend-payload не уходит (он в URL).
export interface EquipmentSearchRequest {
  page: number;
  pageSize: number;
  snapshotDate: string | null;
  sort: SortSpec[] | null;
  filters: FilterSpec[] | null;
}

// Тело запроса POST /inventory/export. Поле `columns` — видимые колонки таблицы
// (camelCase-ключи из COLUMNS); null/[] на бэке = все колонки таблицы.
export interface EquipmentExportRequest extends EquipmentSearchRequest {
  columns?: string[] | null;
}

// Стейт фильтров на фронте (хранится в TableStateService)
export interface FilterState {
  visibleColumns: string[];
  rules: FilterSpec[];
  sort: SortSpec[];
  page: number;
  pageSize: number;
  snapshotDate: string | null;
}

export const DEFAULT_FILTER_STATE: FilterState = {
  visibleColumns: [],
  rules: [],
  sort: [],
  page: 1,
  pageSize: 50,
  snapshotDate: null,
};
